import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import {
  faCalendar,
  faChevronDown,
  faChevronUp,
} from '@fortawesome/pro-solid-svg-icons'
import { isEmpty } from 'lodash-es'

import { Icon } from 'Components/Icon/Icon'

import { Input } from '../_theme/Input/Input'
import { MultidatePickerInputProps } from './MultidatePicker.types'

export const MultidatePickerInput = (props: MultidatePickerInputProps) => {
  const {
    isOpen,
    onFocus,
    value,
    setValue,
    onCloseDatepicker,
    autoComplete,
    e2eSelector,
  } = props
  const intl = useIntl()
  const isFilled = !isEmpty(value)

  const handleContentAfterCustomClick = useCallback(() => {
    if (isOpen) {
      onCloseDatepicker()
    } else if (typeof onFocus === 'function') {
      onFocus()
    }
  }, [isOpen, onFocus, onCloseDatepicker])

  return (
    <Input
      autoComplete={autoComplete}
      contentAfter={
        <Icon icon={isOpen ? faChevronUp : faChevronDown} size={20} />
      }
      contentAfterCustomClick={handleContentAfterCustomClick}
      data-e2e={e2eSelector}
      iconLeft={faCalendar}
      isClearable
      isFilled={isFilled}
      isFormInput={false}
      onClear={() => setValue(null)}
      onClick={onFocus}
      placeholder={intl.formatMessage({ id: 'MultidatePicker_placeholder' })}
      value={value}
    />
  )
}
